export const IT_CONSULTING_AND_ADVISORY_SERVICES = [
    {
        number: "01",
        header: "Software engineering advisory",
        text: "We provide consultation and assist in selecting the most suitable architecture for the entire system, backend or the mobile application."
    },
    {
        number: "02",
        header: "IT strategy consulting",
        text: "We help you create a comprehensive strategy for a digital and technological transformation of your company that matches your business goals."
    }
]

export const WHY_CONSULTING_WITH_US = [
    {
        header: "Stunning experts with unique expertise",
        text: "Behind every exceptional expert, there is a team ready to provide guidance and support throughout the complete development cycle from the beginning.",
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/consulting_and_advisory/it_consulting1.webp"
    }
]
